export default __webpack_public_path__ + "static/media/hero-machinery.67df4138.webp";